import { Environment } from './types/environment.type';

export const environment: Environment = {
  production: true,
  baseUrl: undefined, // https://api.dormerpramet.com/
  googleTagManagerId: 'GTM-TLJ93X',
  spareGoogleTagKey: 'G-DCPR6RVV2E',
  apiKey: 'AIzaSyAX6lXPYnRtZYNSFNngxOL7HymWgxlUcOs',
  surveyIdConfirmationPage: 'nL4c4YD2uUSdQtcF90C4iJJG3bD1ycJOkFea7GHI4IhUNkpMWjBMUzgwUzhKVzRCVDFWOVU3RU9SSi4u',
  surveyIdPopup: 'nL4c4YD2uUSdQtcF90C4iJJG3bD1ycJOkFea7GHI4IhUMUZKMjBYUVBaRlhKWlVHVVZNMlVUNzVWNS4u'
};
